import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';

export interface IGenerateStrategyTargetAudienceChallenges {
  targetAudience: string | null;
  productDescription: string | null;
}

export default function useGenerateStrategyTargetAudienceChallenges() {
  const generateStrategyTargetAudience = (
    strategyTargetAudienceChallenges: IGenerateStrategyTargetAudienceChallenges,
  ) => {
    const request: Request = {
      url: `${ENDPOINTS.assistant.strategy.targetAudienceChallenges}`,
      config: {
        method: 'post',
        data: { data: strategyTargetAudienceChallenges },
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<string[] | null>,
    CronoError,
    IGenerateStrategyTargetAudienceChallenges
  >(generateStrategyTargetAudience, { meta: { silentError: true } });

  return { data, mutate, ...rest };
}
